/* eslint-disable no-console */
const getEmailShareUrl = () => (
  'mailto:?subject='
);

const getFacebookShareUrl = () => (
  'https://www.facebook.com/sharer/sharer.php?u='
);

const getPinterestShareUrl = () => (
  'https://pinterest.com/pin/create/button/?url='
);

const getTwitterShareUrl = () => (
  'https://twitter.com/intent/tweet?text='
);

const getEmailIconUrl = () => (
  '/assets/dist/images/ui/icon-social-email-solid.svg'
);

const getFacebookIconUrl = () => (
  '/assets/dist/images/ui/icon-social-facebook-solid.svg'
);

const getPinterestIconUrl = () => (
  '/assets/dist/images/ui/icon-social-pinterest-solid.svg'
);

const getTwitterIconUrl = () => (
  '/assets/dist/images/ui/icon-social-twitter-solid.svg'
);

const getAssetSharingHtml = (options) => {
  const {
    shareLink,
    description,
    src,
  } = options;
  return `<ul class="list-unstyled d-flex flex-row">
    <li>
      <a href="${getFacebookShareUrl()}${shareLink}" class="footer-icon-facebook" title="Facebook" id="share-fb" target="_blank" rel="noreferrer">Facebook</a>
    </li>
    <li class="ml-4">
      <a href="${getTwitterShareUrl()}Check out this photo from the Graber Design Gallery&url=${shareLink}" title="Twitter" class="footer-icon-twitter" id="share-tw" target="_blank" rel="noreferrer">Twitter</a>
    </li>
    <li class="ml-4">
      <a href="${getPinterestShareUrl()}${shareLink}&media=${src}&description=${description}" title="Pinterest" class="link" id="share-pt" target="_blank" rel="noreferrer">Pinterest</a>
    </li>
    <li class="ml-4">
      <a href="${getEmailShareUrl()}Check%20out%20this%20photo%20from%20the%20Graber%20Design%20Gallery&body=Photo%20link%3A%20${shareLink}%0A%0AAbout%20this%20photo%3A%20'${description}" title="Email" class="link" id="share-em" target="_blank" rel="noreferrer">Email</a>
    </li>
  </ul>`;
};

export {
  getEmailIconUrl,
  getEmailShareUrl,
  getFacebookIconUrl,
  getFacebookShareUrl,
  getPinterestIconUrl,
  getPinterestShareUrl,
  getTwitterIconUrl,
  getTwitterShareUrl,
  getAssetSharingHtml,
};
/* eslint-enable no-console */
